<ng-container>
    <a data-crlat="myBetsBtn" class="btn btn-secondary my-bets-btn" (click)="openMyBets()" [i18n]="'bma.myBets'"> </a>
</ng-container>
